import React, { useCallback, useMemo, useRef,useState } from "react";
import { Container, Row, Col, Button, Stack, Table } from 'react-bootstrap';
import moment from "moment";
import Pagination from '../../components/Pagination/Pagination';

let PageSize = 10;

export default function ProcessLogs({
  processLogs
}) {

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return processLogs.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, processLogs]);

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col sm={8}><h1 className="mt-4 pageTitle">Process Logs</h1></Col>
            <Col sm={4}>
              <Stack direction="horizontal" gap={1}>
                {/* <Button variant="primary" className="mt-4" onClick={() => navigate(`/project/${projectId}/supplier/create`)}><FcPlus /> Create Supplier</Button> */}
              </Stack>
            </Col>
          </Row>
          {/* <hr /> */}
          <Row>
            <Col>
              <Table className="table theme-01 border-bottom" size="sm" responsive>
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0" width="18%">
                      Batch
                    </th>
                    <th scope="col" className="border-0" width="10%">
                      Process Name
                    </th>
                    <th scope="col" className="border-0" width="15%">
                      Log Date
                    </th>
                    {/* <th scope="col" className="border-0">
                      UKey File
                    </th> */}
                    <th scope="col" className="border-0">
                      Message
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentTableData.length ? (
                    currentTableData.map((item, index) => (
                      <tr className="clickable" key={index.toString()}>
                        <td>{item.batchRportId}</td>
                        <td>{item.processName}</td>
                        <td>{moment(new Date(item.logDate)).format("DD/MM/yyyy hh:mm:ss A")}</td>
                        {/* <td>{item._id}</td> */}
                        <td>{item.message}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="flx-content-right">
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={processLogs.length}
                  pageSize={PageSize}
                  onPageChange={page => setCurrentPage(page)}
                />
              </div>
              
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );

}

